var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-action-bar"},[_c('div',{staticClass:"left"},[_vm._t("default")],2),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }